import { IPartnerRecord } from 'clickNgo/entities/partner/models'

import { PARTNER_HISTORY_KEY } from '../configs'

export function getLocalUserHistory(): IPartnerRecord[] {
  if (localStorage) {
    const data = localStorage.getItem(PARTNER_HISTORY_KEY)
    if (data) {
      return JSON.parse(data) as IPartnerRecord[]
    }
  }

  return []
}
